export default {
  ho: "allowCrawlerActivity",
  _o: "baseUrl",
  Eo: "noCookies",
  Io: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Ao: "enableLogging",
  So: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  No: "minimumIntervalBetweenTriggerActionsInSeconds",
  Oo: "sessionTimeoutInSeconds",
  wo: "appVersion",
  Po: "appVersionNumber",
  _a: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  Ba: "localization",
  po: "contentSecurityNonce",
  Ro: "allowUserSuppliedJavascript",
  lo: "inAppMessageZIndex",
  fo: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Co: "doNotLoadFontAwesome",
  Lo: "sdkFlavor",
  tn: "openCardsInNewTab",
};
